import { yieldToMainThread } from '@theme/utilities';

class FlyToWishlist extends HTMLElement {
  /** @type {Element} */
  source;

  /** @type {Element} */
  destination;

  connectedCallback() {
    const intersectionObserver = new IntersectionObserver((entries) => {
      /** @type {DOMRectReadOnly | null} */
      let sourceRect = null;
      /** @type {DOMRectReadOnly | null} */
      let destinationRect = null;

      entries.forEach((entry) => {
        if (entry.target === this.source) {
          sourceRect = entry.boundingClientRect;
        } else if (entry.target === this.destination) {
          destinationRect = entry.boundingClientRect;
        }
      });

      if (sourceRect && destinationRect) {
        this.#animate(sourceRect, destinationRect);
      }

      intersectionObserver.disconnect();
    });
    intersectionObserver.observe(this.source);
    intersectionObserver.observe(this.destination);
  }

  /**
   * @param {DOMRectReadOnly} sourceRect
   * @param {DOMRectReadOnly} destinationRect
   */
  #animate = async (sourceRect, destinationRect) => {
    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2,
      y: sourceRect.top + sourceRect.height / 2,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2,
      y: destinationRect.top + destinationRect.height / 2,
    };

    this.style.setProperty('--start-x', `${startPoint.x}px`);
    this.style.setProperty('--start-y', `${startPoint.y}px`);
    this.style.setProperty('--travel-x', `${endPoint.x - startPoint.x}px`);
    this.style.setProperty('--travel-y', `${endPoint.y - startPoint.y}px`);

    await yieldToMainThread();

    await Promise.allSettled(this.getAnimations().map((a) => a.finished));
    this.remove();
  };
}

if (!customElements.get('fly-to-wishlist')) {
  customElements.define('fly-to-wishlist', FlyToWishlist);
}

document.addEventListener('click', (event) => {
  const wishlistButton = event.target.closest('wishlist-button-block .wk-button');
  if (!wishlistButton) return;

  // Only animate when adding — the app toggles wk-selected before the event
  // bubbles to document, so wk-selected present = item was just added
  if (!wishlistButton.classList.contains('wk-selected')) return;

  const wishlistIcon = document.querySelector('.wishlist-header-link');
  if (!wishlistIcon) return;

  const flyElement = document.createElement('fly-to-wishlist');
  flyElement.source = wishlistButton;
  flyElement.destination = wishlistIcon;
  document.body.appendChild(flyElement);
});
